// The cast: every manager's caricature as transparent cut-outs, posed from the original drawing.
// Files live in public/images/cast/<key>/<pose>.webp. POSES lists what exists per manager; add a pose here when its file lands.
export const CAST_KEYS = {
  Kyle: 'kyle',
  Kevin: 'kevin',
  Bryan: 'bryan',
  'A.J.': 'aj',
  AJ: 'aj',
  Anna: 'anna',
  Josh: 'josh',
  Amir: 'amir',
  Robby: 'robby',
  Ryan: 'ryan',
  Samuel: 'sam',
  Sam: 'sam',
};

const NORMALIZED_CAST_KEYS = Object.fromEntries(
  Object.entries(CAST_KEYS).map(([name, key]) => [name.toLowerCase(), key]),
);

export const POSE_ORDER = ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'shrug', 'sob', 'trophy', 'rage', 'sweat', 'clipboard'];

// Populated from public/images/cast/manifest.json at build time by scripts; kept static so the bundle needs no fetch.
export const CAST_POSES = {
  kyle: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'trophy'],
  kevin: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'trophy', 'clipboard'],
  bryan: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'shrug'],
  aj: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'sob'],
  anna: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'shrug'],
  josh: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'sob'],
  amir: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'shrug', 'rage'],
  robby: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'shrug'],
  ryan: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'sweat'],
  sam: ['base', 'shock', 'point', 'celebrate', 'smug', 'facepalm', 'sweat'],
};

export function castKey(name) {
  if (!name) return null;
  const normalized = String(name).trim().toLowerCase();
  if (NORMALIZED_CAST_KEYS[normalized]) return NORMALIZED_CAST_KEYS[normalized];
  const first = normalized.split(/\s+/)[0];
  return NORMALIZED_CAST_KEYS[first] || null;
}

export function castSrc(key, pose = 'base') {
  return `/images/cast/${key}/${pose}.webp`;
}

export function hasPose(key, pose) {
  return !!key && (CAST_POSES[key] || []).includes(pose);
}
